import type { App } from 'vue';
import { defineAsyncComponent } from 'vue';
import AutoComplete from 'ant-design-vue/es/auto-complete';
import Breadcrumb from 'ant-design-vue/es/breadcrumb';
import Button from 'ant-design-vue/es/button';
import Col from 'ant-design-vue/es/col';
import Collapse from 'ant-design-vue/es/collapse';
import ConfigProvider from 'ant-design-vue/es/config-provider';
import Divider from 'ant-design-vue/es/divider';
import Dropdown from 'ant-design-vue/es/dropdown';
import Form from 'ant-design-vue/es/form';
import Image from 'ant-design-vue/es/image';
import Input from 'ant-design-vue/es/input';
import List from 'ant-design-vue/es/list';
import Menu from 'ant-design-vue/es/menu';
import Modal from 'ant-design-vue/es/modal';
import Pagination from 'ant-design-vue/es/pagination';
import Popover from 'ant-design-vue/es/popover';
import Radio from 'ant-design-vue/es/radio';
import Row from 'ant-design-vue/es/row';
import Select from 'ant-design-vue/es/select';
import Skeleton from 'ant-design-vue/es/skeleton';
import Space from 'ant-design-vue/es/space';
import Tabs from 'ant-design-vue/es/tabs';
import Tag from 'ant-design-vue/es/tag';
import Timeline from 'ant-design-vue/es/timeline';
import Tooltip from 'ant-design-vue/es/tooltip';
import Typography from 'ant-design-vue/es/typography';
import message from 'ant-design-vue/es/message';
import notification from 'ant-design-vue/es/notification';

import 'ant-design-vue/es/auto-complete/style/css';
import 'ant-design-vue/es/breadcrumb/style/css';
import 'ant-design-vue/es/button/style/css';
import 'ant-design-vue/es/col/style/css';
import 'ant-design-vue/es/collapse/style/css';
import 'ant-design-vue/es/config-provider/style/css';
import 'ant-design-vue/es/divider/style/css';
import 'ant-design-vue/es/dropdown/style/css';
import 'ant-design-vue/es/form/style/css';
import 'ant-design-vue/es/image/style/css';
import 'ant-design-vue/es/input/style/css';
import 'ant-design-vue/es/list/style/css';
import 'ant-design-vue/es/menu/style/css';
import 'ant-design-vue/es/modal/style/css';
import 'ant-design-vue/es/pagination/style/css';
import 'ant-design-vue/es/popover/style/css';
import 'ant-design-vue/es/radio/style/css';
import 'ant-design-vue/es/row/style/css';
import 'ant-design-vue/es/select/style/css';
import 'ant-design-vue/es/skeleton/style/css';
import 'ant-design-vue/es/space/style/css';
import 'ant-design-vue/es/tabs/style/css';
import 'ant-design-vue/es/tag/style/css';
import 'ant-design-vue/es/timeline/style/css';
import 'ant-design-vue/es/tooltip/style/css';
import 'ant-design-vue/es/typography/style/css';
import 'ant-design-vue/es/message/style/css';
import 'ant-design-vue/es/notification/style/css';
import '../../resource/css/skeleton.css';

// Register only component families actually used by V2; child components are
// registered by each family's official install() implementation.
export default {
  install(app: App) {
    [AutoComplete, Breadcrumb, Button, Col, Collapse, ConfigProvider, Divider, Dropdown, Form, Image, Input, List, Menu, Modal, Pagination, Popover, Radio, Row, Select, Skeleton, Space, Tabs, Tag, Timeline, Tooltip, Typography].forEach(component => app.use(component));
    // 首页不使用表格；只在产品价格等页面实际渲染表格时加载组件和样式。
    app.component('ATable', defineAsyncComponent(() => Promise.all([
      import(/* webpackChunkName: "ui-table" */ 'ant-design-vue/es/table'),
      import(/* webpackChunkName: "ui-table" */ 'ant-design-vue/es/table/style/css')
    ]).then(([module]) => module.default)));
    Object.assign(app.config.globalProperties, {
      $message: message, $notification: notification,
      $info: Modal.info, $success: Modal.success, $error: Modal.error,
      $warning: Modal.warning, $confirm: Modal.confirm, $destroyAll: Modal.destroyAll
    });
  }
};
